
(function() {
  var result = { translations: { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.975"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.975",
    "ar-eg": "static-7.975",
    "bg": "static-7.975",
    "bn": "static-7.975",
    "ca-es": "static-7.975",
    "cs": "static-7.975",
    "da": "static-7.975",
    "de": "static-7.975",
    "el": "static-7.975",
    "en-gb": "static-7.975",
    "en": "static-7.975",
    "es-mx": "static-7.975",
    "es": "static-7.975",
    "fi": "static-7.975",
    "fr-ca": "static-7.975",
    "fr": "static-7.975",
    "he-il": "static-7.975",
    "hr": "static-7.975",
    "hu": "static-7.975",
    "id": "static-7.975",
    "it": "static-7.975",
    "ja": "static-7.975",
    "ko": "static-7.975",
    "lt": "static-7.975",
    "ms": "static-7.975",
    "nl": "static-7.975",
    "no": "static-7.975",
    "pl": "static-7.975",
    "pt-br": "static-7.975",
    "pt-pt": "static-7.975",
    "ro": "static-7.975",
    "ru": "static-7.975",
    "sk": "static-7.975",
    "sl": "static-7.975",
    "sv": "static-7.975",
    "th": "static-7.975",
    "tl": "static-7.975",
    "tr": "static-7.975",
    "uk": "static-7.975",
    "vi": "static-7.975",
    "x-pseudo": "static-7.975",
    "zh-cn": "static-7.975",
    "zh-hk": "static-7.975",
    "zh-tw": "static-7.975"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.975'}); }
})();


